// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"1b1b97f9c58a3e8c","5763":"c1105dde0373d3e8","6893":"1b65b1d444d117fe","6974":"41dcc2a75799d76a","7222":"2d28ecda57324b1b","7937":"f0e7e6a330d3285d"}[chunkId] + ".js";
};